import {
  clearBrowserCachesForLatestVersion,
  reloadToLatestSpaVersion,
} from '@/support/appCacheRefresh';

const VERSION_RELOAD_TARGET_KEY = 'suite241_version_reload_target';

export type VersionCheckResult = 'current' | 'reloading' | 'reload-skipped' | 'unavailable';

const versionFileUrl = (): string => {
  const baseUrl = process.env.BASE_URL || '/';
  const url = new URL(`${baseUrl}version.json`, window.location.origin);
  url.searchParams.set('version_check', String(Date.now()));

  return url.toString();
};

const normalizedVersion = (value: unknown): string => String(value || '').trim();

export const currentSpaVersion = (): string => normalizedVersion(process.env.VUE_APP_VERSION);

export const checkForLatestSpaVersion = async (
  embeddedVersion = currentSpaVersion()
): Promise<VersionCheckResult> => {
  try {
    const response = await fetch(versionFileUrl(), {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
      },
    });

    if (!response.ok) return 'unavailable';

    const remoteVersion = normalizedVersion((await response.json())?.version);
    const localVersion = normalizedVersion(embeddedVersion);
    if (!remoteVersion) return 'unavailable';

    if (remoteVersion === localVersion) {
      window.sessionStorage.removeItem(VERSION_RELOAD_TARGET_KEY);
      return 'current';
    }

    if (window.sessionStorage.getItem(VERSION_RELOAD_TARGET_KEY) === remoteVersion) {
      window.sessionStorage.removeItem(VERSION_RELOAD_TARGET_KEY);
      return 'reload-skipped';
    }

    window.sessionStorage.setItem(VERSION_RELOAD_TARGET_KEY, remoteVersion);

    try {
      await clearBrowserCachesForLatestVersion();
    } catch (error) {
      console.warn('Le nettoyage complet du cache a échoué avant la mise à jour :', error);
    }

    reloadToLatestSpaVersion(remoteVersion);
    return 'reloading';
  } catch (error) {
    console.warn('Impossible de vérifier la dernière version de l’application :', error);
    return 'unavailable';
  }
};
